import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, Suspense as _Suspense } from "vue"

const _hoisted_1 = {
  key: 1,
  id: "park-widget-page-home",
  class: "row g-5 g-xxl-8 d-none d-sm-none"
}
const _hoisted_2 = { class: "col-md-12 col-lg-12 col-xl-8" }
const _hoisted_3 = { class: "row g-5 g-xxl-8" }
const _hoisted_4 = {
  key: 0,
  class: "col-xl-4"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = {
  key: 1,
  class: "col-xl-12"
}
const _hoisted_8 = { class: "card card-custom card-stretch mb-xxl-8" }
const _hoisted_9 = { class: "card-header align-items-center p-4" }
const _hoisted_10 = { class: "card-title" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-sm-6 col-lg-9" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  key: 0,
  class: "col-sm-4 col-lg-3 px-0 pb-3"
}
const _hoisted_15 = { class: "svg-icon svg-icon-1" }
const _hoisted_16 = { class: "col-12 mt-5" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "card-toolbar mt-10" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-arrow-right",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, null, -1)
const _hoisted_21 = { class: "card-body px-2" }
const _hoisted_22 = {
  key: 0,
  id: "feed-collection-wrapper",
  class: "row justify-content-center justify-content-md-start"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_page = _resolveComponent("header-page")!
  const _component_park_widget = _resolveComponent("park-widget")!
  const _component_about_city = _resolveComponent("about-city")!
  const _component_be_member_engage = _resolveComponent("be-member-engage")!
  const _component_news_caroussel = _resolveComponent("news-caroussel")!
  const _component_explore_city_categories = _resolveComponent("explore-city-categories")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_feed_widget = _resolveComponent("feed-widget")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.home)
      ? (_openBlock(), _createBlock(_component_header_page, {
          key: 0,
          id: "header-page-home",
          title: _ctx.home.title,
          subtitle: _ctx.home.shortDescription,
          search: _ctx.home.search,
          "bg-image": _ctx.home.banner,
          "bg-image-small": _ctx.home.bannerSmall,
          lg: false,
          bgHex: "#fff",
          breadcrumbs: _ctx.home.breadcrumbs,
          margin: "mb-xxl-6"
        }, null, 8, ["title", "subtitle", "search", "bg-image", "bg-image-small", "breadcrumbs"]))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_park_widget, {
              title: _ctx.park.title,
              subtitle: _ctx.park.subtitle,
              toolbarButtonLabel: _ctx.park.buttonLabel,
              "url-path": _ctx.park.href,
              collection: _ctx.park.featureCollection
            }, null, 8, ["title", "subtitle", "toolbarButtonLabel", "url-path", "collection"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_about_city, {
                id: "about-city-page-home",
                class: "col-12"
              }),
              (_ctx.widget && _ctx.widget.title)
                ? (_openBlock(), _createBlock(_component_be_member_engage, {
                    key: 0,
                    id: "be-member-engage-page-home",
                    title: _ctx.widget.title,
                    subtitle: _ctx.widget.description,
                    actionBtnLabel: _ctx.widget.metadata.buttonLabel,
                    actionBtnImage: _ctx.widget.metadata.buttonImage,
                    class: "col-12"
                  }, null, 8, ["title", "subtitle", "actionBtnLabel", "actionBtnImage"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.news.menu && false)
          ? (_openBlock(), _createBlock(_component_news_caroussel, {
              key: 0,
              id: "news-caroussel-page-home",
              class: "col-12",
              title: _ctx.news.title,
              items: _ctx.news.menu,
              "current-active": 8
            }, null, 8, ["title", "items"]))
          : _createCommentVNode("", true),
        _createVNode(_component_explore_city_categories, {
          id: "explore-city-categories-page-home",
          title: _ctx.menuModalData.title,
          subtitle: _ctx.menuModalData.subtitle,
          collection: _ctx.menuModalData.featureCollection.filter((x) => x.enabled),
          class: "col-12"
        }, null, 8, ["title", "subtitle", "collection"])
      ]),
      (_ctx.feed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h3", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("h1", {
                        class: "fw-bolder text-dark fs-1",
                        style: {"font-size":"calc(1.2rem + 0.7vw) !important","font-weight":"400"},
                        innerHTML: _ctx.feed.title
                      }, null, 8, _hoisted_13)
                    ]),
                    (_ctx.feed.url)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-color-primary btn-active-light-primary",
                            "data-kt-menu-placement": "bottom-end",
                            "data-kt-menu-flip": "top-end",
                            onClick: _cache[0] || (_cache[0] = () => _ctx.$router.push(_ctx.feed.url))
                          }, [
                            _createElementVNode("span", _hoisted_15, [
                              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
                            ]),
                            _createTextVNode(" Ver Todos ")
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", {
                        class: "font-weight-light fs-3 my-3 text-gray-800",
                        innerHTML: _ctx.feed.shortDescription
                      }, null, 8, _hoisted_17)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_router_link, {
                        to: "/adicionar-negocio",
                        class: "btn btn-md btn-primary"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_19,
                          _createTextVNode(" Comece a planejar seu negócio agora ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _hoisted_20
              ]),
              _createElementVNode("div", _hoisted_21, [
                (_ctx.feed.metadata.collection)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feed.metadata.collection, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id,
                          class: "col-lg-6 col-xl-6 me-n1 my-4"
                        }, [
                          (_openBlock(), _createBlock(_Suspense, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_feed_widget, {
                                title: item.name,
                                subtitle: item.shortDescription,
                                "banner-small": true,
                                image: `ai-tools/${item.metadata.images[0].href}`,
                                url: item.href
                              }, null, 8, ["title", "subtitle", "image", "url"])
                            ]),
                            _: 2
                          }, 1024))
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}